import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import SupportedNetworks from './components/SupportedNetworks';
import DownloadApp from './components/DownloadApp';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />
      <HowItWorks />
      <Features />
      <SupportedNetworks />
      <DownloadApp />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
